<div class="rcp-py-4">
    <app-data-table
        [searchNote]="searchNote()"
        [fullRowSelection]="true"
        [notFoundContent]="notFoundContent()"
        [rowId]="'name'"
        [tableId]="'qr-code-list'"
        [columns]="dataColumns()"
        [page]="1"
        [pageSize]="10"
        [sortBy]="'creationDate'"
        [onAddTitle]="title()"
        [tableActions]="tableActions()"
        (fetchData)="actionTableAction($event)"
        (onFullRowClick)="actionTableOnRowClick($event)"
    />
</div>
